import { MenuItem, TextField } from "@mui/material";
import { MastercardLogo } from "./MastercardLogo";

export const CardSelector = ({ cards = [], selectedId, onSelect }) => {
  if (!cards.length) return null;

  const selected = cards.find((card) => card.id === selectedId) || cards[0];

  return (
    <div className="cartoes-card-selector app-card">
      <label className="cartoes-card-selector__label" htmlFor="cartoes-card-select">
        Selecionar cartão
      </label>
      <TextField
        id="cartoes-card-select"
        select
        fullWidth
        size="small"
        value={selectedId || cards[0]?.id}
        onChange={(event) => onSelect(event.target.value)}
        className="cartoes-card-selector__field"
        SelectProps={{
          renderValue: () => (
            <span className="cartoes-card-selector__value">
              <MastercardLogo className="cartoes-card-selector__brand" />
              <span className="cartoes-card-selector__text">
                <strong>{selected.label}</strong>
                <span>Final {selected.last4}</span>
              </span>
            </span>
          ),
          MenuProps: {
            PaperProps: { className: "cartoes-card-selector__menu" },
          },
        }}
      >
        {cards.map((card) => (
          <MenuItem key={card.id} value={card.id} className="cartoes-card-selector__option">
            <MastercardLogo className="cartoes-card-selector__brand" />
            <span className="cartoes-card-selector__option-text">
              <strong>{card.label}</strong>
              <span>
                Final {card.last4} · {card.holderName}
              </span>
            </span>
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
};
